import SubNavBarDesktopInnerContainer from './SubNavBarDesktopInner.container';
import SubNavBarDesktopInner from './SubNavBarDesktopInner';
export default SubNavBarDesktopInnerContainer(SubNavBarDesktopInner);
